import type { ErrorMessage as AssistantServiceErrorMessage } from '@atlassian/ai-agent-streaming/ai-agent-streaming-models';
import type { ConvoAIErrorMessage } from '@atlassian/ai-agent-streaming/convo-ai-streaming-models';

export enum AIGQLErrors {
	NOT_ENOUGH_CONTENT = 'NOT_ENOUGH_CONTENT',
	TOO_MUCH_CONTENT = 'TOO_MUCH_CONTENT',
	TOO_MANY_REQUEST = 'RATE_LIMIT',
	AUP_VIOLATION = 'AUP_VIOLATION',
	GENERAL_ERROR = 'GENERAL_ERROR',
}

export type AIErrorType =
	| `${AssistantServiceErrorMessage}`
	| `${AIGQLErrors}`
	| `${ConvoAIErrorMessage}`;

export enum AIErrorLinkType {
	Troubleshooting = 'Troubleshooting',
	RateLimit = 'RateLimit',
	AupViolation = 'AupViolation',
}

export enum ErrorMessageKeys {
	GENERAL_ERROR = 'generalError',
	NOT_ENOUGH_CONTENT = 'notEnoughContent',
	TOO_MUCH_CONTENT = 'tooMuchContent',
	RATE_LIMIT = 'rateLimit',
	AUP_VIOLATION = 'aupViolation',
}

export enum ConvoAIErrorMessageMap {
	RATE_LIMIT = 'rateLimit',
	ANSWER_UNAVAILABLE_FOR_CONTENT = 'notEnoughContent',
	ACCEPTABLE_USE_VIOLATIONS = 'aupViolation',
	BAD_REQUEST = 'generalError',
	UNEXPECTED = 'generalError',
	TIMEOUT = 'generalError',
	NOT_ENOUGH_CONTENT_ERROR = 'notEnoughContent',
}

export enum BaseErrorMessageMap {
	GENERAL_ERROR = 'generalError',
	NETWORK_ERROR = 'generalError',
	NO_ANSWER = 'generalError',
	NO_AGENT = 'generalError',
	PLUGIN_ERRORED = 'generalError',
	AI_DISABLED = 'generalError',
	OPENAI_RATE_LIMIT = 'rateLimit',
	AUP_VIOLATION = 'aupViolation',
	NOT_ENOUGH_CONTENT = 'notEnoughContent',
	// typo comes from the backend
	// https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
	ASWER_UNAVAILABLE_FOR_CONTENT = 'notEnoughContent',
	TOO_MUCH_CONTENT = 'tooMuchContent',
	NOT_FOUND = 'generalError',
	INTERNAL_SERVER_ERROR = 'generalError',
}

export const ErrorTypeErrorMessageMap: {
	ACCEPTABLE_USE_VIOLATIONS: ConvoAIErrorMessageMap.ACCEPTABLE_USE_VIOLATIONS;
	AI_DISABLED: BaseErrorMessageMap.GENERAL_ERROR;
	ANSWER_UNAVAILABLE_FOR_CONTENT: ConvoAIErrorMessageMap.ANSWER_UNAVAILABLE_FOR_CONTENT;
	ASWER_UNAVAILABLE_FOR_CONTENT: BaseErrorMessageMap.NOT_ENOUGH_CONTENT;
	AUP_VIOLATION: BaseErrorMessageMap.AUP_VIOLATION;
	BAD_REQUEST: ConvoAIErrorMessageMap.BAD_REQUEST;
	GENERAL_ERROR: BaseErrorMessageMap.GENERAL_ERROR;
	INTERNAL_SERVER_ERROR: BaseErrorMessageMap.GENERAL_ERROR;
	NETWORK_ERROR: BaseErrorMessageMap.GENERAL_ERROR;
	NO_AGENT: BaseErrorMessageMap.GENERAL_ERROR;
	NO_ANSWER: BaseErrorMessageMap.GENERAL_ERROR;
	NOT_ENOUGH_CONTENT: BaseErrorMessageMap.NOT_ENOUGH_CONTENT;
	NOT_ENOUGH_CONTENT_ERROR: ConvoAIErrorMessageMap.ANSWER_UNAVAILABLE_FOR_CONTENT;
	NOT_FOUND: BaseErrorMessageMap.GENERAL_ERROR;
	OPENAI_RATE_LIMIT: BaseErrorMessageMap.OPENAI_RATE_LIMIT;
	PLUGIN_ERRORED: BaseErrorMessageMap.GENERAL_ERROR;
	RATE_LIMIT: ConvoAIErrorMessageMap.RATE_LIMIT;
	TIMEOUT: ConvoAIErrorMessageMap.BAD_REQUEST;
	TOO_MUCH_CONTENT: BaseErrorMessageMap.TOO_MUCH_CONTENT;
	UNEXPECTED: ConvoAIErrorMessageMap.BAD_REQUEST;
} = { ...ConvoAIErrorMessageMap, ...BaseErrorMessageMap };

export enum ErrorMessageKeyErrorLinkMap {
	generalError = 'Troubleshooting',
	rateLimit = 'RateLimit',
	aupViolation = 'AupViolation',
	notEnoughContent = 'Troubleshooting',
	tooMuchContent = 'Troubleshooting',
}
